export default "__VITE_ASSET__Cv_Gvga___";